module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_5-308d8cbcdc3c73637ba2edb162efbe89.jpg";